<template>
  <div :class="langShow?'button-select':'button-selecten'">
    <slot name="header"></slot>
    <el-skeleton  :loading="data.length==0" animated :rows="7">
    <template v-for="item in data">
      <div class="row" :key="item.value" v-if="item.children.length > 0">
        <div class="row-title" v-show="(multipleCompany && item.value!=0) || !multipleCompany">
          <el-checkbox v-show="multipleCompany" :indeterminate="item.isIndeterminate" @change="(val)=>handleCheckAllChange(val, item)" v-model="item.checked"></el-checkbox>
          <span>{{ item.label }}</span> 
        </div>
        <div class="row-title" v-show="multipleCompany && item.value==0">
          <el-checkbox v-show="multipleCompany" :indeterminate="chooseAllIndeterminate" @change="(val)=>handleCheckAllCountry(val, item)" v-model="chooseAllChecked"></el-checkbox>
          <span>{{$i18.language("全选")}}</span> 
        </div>
        <div class="selects">
          <template v-for="c in item.children">
            <!-- 如果是全选模式变成全选且不展示全部国家 -->
            <template v-if="(multipleCompany&&c.value!=0) || !multipleCompany">
              <el-tooltip v-if="$url.countryPermission(c.value) && ((c.label.length * 2 + String(c.count).length > 17 && c.flag) || (!c.flag && c.label.length * 2 + String(c.count).length > 21))" :key="c.value" class="item" effect="dark" :content="c.label" placement="top">
                <div @click="changeSelect(c, item)" class="select-item"  v-bind:class="single ? (value === c.value ? 'active' : '') : value.indexOf(c.value) > -1 ? 'active' : ''">
                  <div class="name-left">
                    <div v-if="c.flag" :style="{backgroundPosition:c.value==0?`-384px  -166px`:`${c.x*-1}px  ${c.y*-1}px`}"   :class="[c.isOpen==false || multipleCompany&&c.value==0 ? ' backcolor' : 'backcolor3','all-country-map-img']" />
                    <!-- <img v-if="c.flag" :src="c.flag" alt="" :class="c.isOpen==false || multipleCompany&&c.value==0 ? ' backcolor' : 'backcolor3'" /> -->
                    <div class="name">{{ c.label }}</div>
                     <svg-icon name="new-tobottom" class="newIcon" v-if="c.isNew==true"></svg-icon>
                  </div>
                  <div class="count" v-if="c.count !== undefined&&c.count !== 0">({{ c.count }})</div>
                </div>
              </el-tooltip>
              <template v-else>
                <div :key="c.value" v-if="$url.countryPermission(c.value)" @click="changeSelect(c, item)" class="select-item"  v-bind:class="[single ? (value === c.value ? 'active' : '') : value.indexOf(c.value) > -1 ? 'active' : '',]">
                  <div class="name-left">
                   
                    <div v-if="c.flag" :style="{backgroundPosition:c.value==0?`-384px  -166px`:`${c.x*-1}px  ${c.y*-1}px`}"   :class="[c.isOpen==false || multipleCompany&&c.value==0 ? ' backcolor' : 'backcolor3','all-country-map-img']" />
                    <!-- <img v-if="c.flag" :src="c.flag" alt="" :class="c.isOpen==false || multipleCompany&&c.value==0 ? ' backcolor' : 'backcolor3'" /> -->
                    <div class="name">{{ c.label }}</div>
                    <svg-icon name="new-tobottom" class="newIcon" v-if="c.isNew==true"></svg-icon>
                  </div>
                  <div class="count" v-if="c.count !== undefined&&c.count !== 0">({{ c.count ? c.count : 0 }})</div>
                </div>
              </template>
            </template>
            
          </template>
        </div>
      </div>
    </template>
  </el-skeleton>
  </div>
</template>

<script>
export default {
  name: 'ButtonSelect',
  props: {
    data: {
      type: Array
    },
    single: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Number, String]
    },
    multipleCompany: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      langShow:localStorage.getItem("language")=='en'?false:true,
    }
  },
  computed: {
    chooseAllIndeterminate: {
      get() {
        if(!this.data?.length) return false
        let checked = this.data.filter(item=>item.value!==0 && (item.isIndeterminate||item.checked)) 
        if(!checked.length) return undefined
        let val = checked.length && !this.chooseAllChecked
        return val
      },
      set(val) {
       
      }
    },
    chooseAllChecked: {
      get() {
        if(!this.data?.length) return false
        let val = this.data.filter(item=>item.value!==0).every(item=>item.checked)
        return val
      },
      set(val) {

      }
    },
  },
  methods: {
    // 全选和非全选
    handleCheckAllChange(val, data) {
      data.children = data.children.map(item=>{
        item.checkout = val;
        return item
      })
      this.$emit('change-select-all', {checked: val, data})
      data.isIndeterminate = false
    },
    // 全选按钮
    handleCheckAllCountry(val, data) {
      let country = this.data.filter(item=>item.value!==0).map(item=>{
        return this.handleCheckAllChange(val, item)
      })
      this.$emit("update:data", country)
    },
    // 批量选中国家后操作国家选项
    handleCheckedCitiesChange(child, data) {
      child.checkout = !this.value.includes(child.value)
      if(data?.children?.length) {
        data.children.forEach(el=>{
          if(el.value!==child.value) {
            el.checkout = this.value.includes(el.value)
          }
        })
      }
      this.$emit('change-select-all', {checked: false, data})
    },
    // 切换选中国家数据
    changeSelect(c, data) {
      if(this.multipleCompany&&c.value==0) return
      if(c.isOpen){
        if(this.multipleCompany) {
          this.handleCheckedCitiesChange(c, data)
        } else {
          this.$emit('change-select', c)
        }
      }else{
        this.$message({
        message:this.$t('message.noPermission'),
        type: 'warning'
      }); 
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.button-select {
  .row {
    display: flex;
    margin-bottom: 8px;
    .row-title {
      color: $--color-active;
      min-width: 84px;
      text-align: right;
      line-height: 24px;
      display: flex;
      white-space: nowrap;
      justify-content: space-between;
    }
    .selects {
      margin-left: 10px;
      display: flex;
      flex-wrap: wrap;
        .backcolor {
           opacity: 0.1;
          // filter: grayscale(100%);
        //  background:#F1F3F4;
        }
        .backcolor3 {
        
        }
      .select-item {
        border-radius: 4px;
        border: 1px solid $--color-border;
        margin-bottom: 8px;
        margin-right: 10px;
        padding: 3px 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        width: 146px;
         position: relative;
        // overflow: hidden;
        
        .name-left {
          display: flex;
          align-items: center;
          overflow: hidden;
          .newIcon{
            font-size: 23px;
            position: absolute;
            right:0;
            top:-13px;
          }
        }
        .name {
          margin-left: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .count {
        }
        img {
          height: 13px;
        }
        &.active {
          border-color: mix($--color-white, $--color-default, 50%);
          background-color: mix($--color-white, $--color-default, 90%);
          color: $--color-default;
        }
      }
    }
  }
}
.button-selecten {
  .row {
    display: flex;
    margin-bottom: 8px;
    .row-title {
      color: $--color-active;
      min-width: 124px;
      text-align: right;
      line-height: 24px;
      display: flex;
      white-space: nowrap;
      justify-content: space-between;
      margin-left: 20px;
    }
    .selects {
      margin-left: 10px;
      display: flex;
      flex-wrap: wrap;
        .backcolor {
           opacity: 0.1;
          // filter: grayscale(100%);
        //  background:#F1F3F4;
        }
        .backcolor3 {
        
        }
      .select-item {
        border-radius: 4px;
        border: 1px solid $--color-border;
        margin-bottom: 8px;
        margin-right: 10px;
        padding: 3px 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        width: 146px;
        // overflow: hidden;
        position:relative;
        .name-left {
          display: flex;
          align-items: center;
          overflow: hidden;
          .newIcon{
            font-size: 20px;
            position: absolute;
            right:0;
            top:-13px;
          }
        }
        .name {
          margin-left: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .count {
        }
        img {
          height: 13px;
        }
        &.active {
          border-color: mix($--color-white, $--color-default, 50%);
          background-color: mix($--color-white, $--color-default, 90%);
          color: $--color-default;
        }
      }
    }
  }
}
.all-country-map-img{
  height:13px;
  width: 20px;
  background: url('https://et.topease.net/sou/img/country_flag.png') no-repeat;
  // width:20px;
}
</style>
